const SCHOOL_TERMINAL_GROUPS = [
  {
    daerah: 'Tanah Merah',
    terminal: 'Terminal 1',
    schools: ['SMK Ipoh', 'SMK Tan Sri Mohamed Yaacob'],
  },
  {
    daerah: 'Tanah Merah',
    terminal: 'Terminal 2',
    schools: ['SMK Tanah Merah 1', 'SMK Tanah Merah 2'],
  },
  {
    daerah: 'Bachok',
    terminal: 'Terminal 1',
    schools: ['SMK Sri Gunung', 'SMU(A) Darul Ulum Al-Muhammadiah'],
  },
  {
    daerah: 'Bachok',
    terminal: 'Terminal 2',
    schools: ['SMK Kandis', 'SMK Kubang Golok', 'SMU(A) Darul Iman'],
  },
  {
    daerah: 'Gua Musang',
    terminal: 'Terminal 1',
    schools: ['SMK Bandar Chiku', 'SMK Paloh', 'SMK Chiku 2'],
  },
  {
    daerah: 'Gua Musang',
    terminal: 'Terminal 2',
    schools: ['SMK Tengku Indra Petra', 'SMK Tengku Indra Petra 2'],
  },
  {
    daerah: 'Kuala Krai',
    terminal: 'Terminal 1',
    schools: ['SMK Keroh', 'SMK Kuala Krai'],
  },
  {
    daerah: 'Kuala Krai',
    terminal: 'Terminal 2',
    schools: ['SMK Bandar Kuala Krai', 'SMK Sultan Yahya Petra 1'],
  },
  {
    daerah: 'Jeli',
    terminal: 'Terminal 1',
    schools: ['SMK Jeli', 'SMK Jeli 2'],
  },
  {
    daerah: 'Jeli',
    terminal: 'Terminal 2',
    schools: ['SMK Kuala Balah', 'SMK Batu Melintang', 'SMK Ayer Lanas'],
  },
];

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { SCHOOL_TERMINAL_GROUPS };
}

export { SCHOOL_TERMINAL_GROUPS };
export default SCHOOL_TERMINAL_GROUPS;
